module.exports = __webpack_public_path__ + "media/images/kyoto_banner_sp-9c26979cbca9b32926326e6f03e8c617.jpg";